var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRoadBattery = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.893 16.111-5.34-13.333C17.363 2.304 16.95 2 16.495 2h-3.728l.094.965c.02.197-.123.368-.304.368h-1.114c-.181 0-.323-.171-.304-.368L11.233 2H7.505c-.455 0-.869.304-1.059.778L1.107 16.11c-.353.883.21 1.889 1.06 1.889h7.518l.393-4.07c.033-.34.295-.597.608-.597h2.628c.313 0 .575.258.608.597l.393 4.07h7.519c.849 0 1.412-1.006 1.059-1.889ZM10.946 4.965a.345.345 0 0 1 .1-.213.291.291 0 0 1 .204-.085h1.5c.157 0 .288.128.305.298l.175 1.816c.029.295-.183.552-.455.552h-1.549c-.272 0-.484-.257-.455-.552l.175-1.816ZM13.056 12h-2.112c-.363 0-.646-.343-.608-.737l.194-2c.033-.339.295-.596.608-.596h1.724c.313 0 .575.257.608.596l.193 2c.039.394-.244.737-.607.737Z",
  fill: "#697077"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.203 9.698-6.545 6.905 6.545-6.905Zm0 0a1.035 1.035 0 0 1 1.269-.185l.313.18v.1a1.032 1.032 0 0 1 .157.92l-1.74-1.015Zm-4.549 12.776-.596-.185 1.222-3.945h-1.87a1.037 1.037 0 0 1-.95-.621l.573-.25 2.31 5.4a.411.411 0 0 1-.679-.132.403.403 0 0 1-.01-.267Zm0 0 1.28-4.13-1.28 4.13Z",
  fill: "#697077",
  stroke: "#fff",
  strokeWidth: 1.25
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(13 8)",
  d: "M0 0h12v15H0z"
})))));
export default SvgRoadBattery;